import {QUERY_KEYS} from '@/queryClient'
import {useQuery} from '@tanstack/react-query'
import {httpGetEventDetails} from '../services/events.http'

export const useGetEventDetails = ({eventId, hash = undefined}: {eventId: string; hash?: string | null}) =>
    useQuery({
        queryKey: [QUERY_KEYS.EVENT_DETAILS, eventId],
        queryFn: () => httpGetEventDetails({eventId, hash})
    })
